import { create } from 'zustand';

export const $subscribeUpdate = create<boolean>(() => false);
